export enum Comparison {
  IS = 'eq',
  IS_NOT = 'ne',
  GREATER_THAN = 'gt',
  LESS_THAN = 'ls',
  IN = 'in',
  OUT = 'out',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  KNOWN = 'known',
  UNKNOWN = 'unknown',
}

export type ConditionDetails = { attribute: string; comparison: string; value: string };

export type SingleCondition = Partial<Condition & ConditionDetails>;

export type Condition = { conditions: SingleCondition[]; operator: 'and' | 'or' };
